import React from 'react';
import { connect } from 'react-redux';
import { Select, Card, Typography, Row, Col, Form, DatePicker } from 'antd';
import { REGIONS } from '../../config/constants/DropDownForms';
import moment from 'moment';
import 'moment/locale/es-mx';
import locale from 'antd/es/date-picker/locale/es_ES';
import { SET_PREVIEW_DATA } from '../../state/lease_contract/types';
import PropTypes from 'prop-types';

const { Option, OptGroup } = Select;
const { Title } = Typography;

const PlaceForm = ({ previewData, setPreview }) => {

  const savePreview = (data) => {
    setPreview({
      ...previewData,
      ...data
    });
  };

  const disabledDate = current => {
    return current && current > moment().endOf('day');
  };

  return (
    <Card className="mb-4">
      <Row className="mb-2">
        <Col span={24}>
          <Title level={3} className="text-purple mb-0">Lugar y fecha de firma del contrato</Title>
          <p className="subtitle-text">Ingresa la comuna donde se encuentra el inmueble a arrendar y la fecha de firma</p>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={12} className="position-relative">
          <Form.Item
            name="citySign"
            label="Comuna de firma del contrato"
            rules={[{ required: true, message: 'Debes seleccionar una opción' }]}
            className="position-relative"
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Seleccionar"
              showSearch
              size="large"
              onSelect={(value) => savePreview({ citySign: value })}
            >
              {REGIONS.map((region, key) => (
                <OptGroup key={key} label={region.region}>
                  {region.comunas.map((comuna, key) => (
                    <Option key={key} value={`${comuna}, ${region.region}`}>{comuna}</Option>
                  ))}
                </OptGroup>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} md={12} className="position-relative">
          <div className="ant-col ant-form-item-label position-relative d-flex align-items-center">
            <label className="ant-form-item-required mr-1">Fecha en que se firmará el Contrato</label>
          </div>
          <Form.Item
            name="dateSign"
            rules={[{ required: true, message: 'Debes seleccionar una fecha' }]}
          >
            <DatePicker
              disabledDate={disabledDate}
              locale={locale}
              format="DD-MM-YYYY"
              style={{ width: '100%' }}
              placeholder="Seleccionar"
              size="large"
              onChange={(value) => savePreview({ dateSign: new Date(value).toISOString() })}
            />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

PlaceForm.propTypes = {
  previewData: PropTypes.object.isRequired,
  setPreview: PropTypes.func.isRequired,
};

const data = (state) => ({
  previewData: state.contract.previewData,
});

const actions = (dispatch) => ({
  setPreview: (data) => dispatch({ type: SET_PREVIEW_DATA, payload: { ...data } }),
});

export default connect(data, actions)(PlaceForm);